<div class="category-card" [class.card]="isMobile()">
  <div class="card-header">
    <span class="icon" [style.--icon-url]="'url(' + icon() + ')'"></span>
    <span class="title">{{ displayTitle() }}</span>
    <div class="pills">
      @for (criterion of visibleCriteria(); track $index) {
        <span class="pill" [class.good]="isCriterionGood(criterion)"></span>
      }
    </div>
    <span class="score">{{ scoreText() }}</span>
  </div>

  @if (visibleCriteria().length) {
    <div class="card-body">
      @for (criterion of visibleCriteria(); track criterion.label) {
        <div class="criterion">
          <span class="criterion-label">
            <span class="dot" [class.good]="isCriterionGood(criterion)"></span>
            <span class="criterion-title">{{ criterion.label }}</span>
          </span>
          <div class="criterion-value-col">
            @if (criterion.value) {
              <span class="criterion-value">{{ criterion.value }}</span>
            }
            @if (percentileText(criterion); as text) {
              <span class="criterion-description">{{ text }}</span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
